import utils from "utils";
import { gmiRequest } from "actions/request";
import { actions, services } from "@ehi/global-marketing-interface";

export const addAdditionalDriverDetails = (formData) => (dispatch) => {
    const data = {};
    data.payload = utils.profile.driverProfilePayloadParser(formData);

    return dispatch(
        gmiRequest({
            action: actions.request({
                service: services.gma.reservations.addAdditionalDriver,
                data,
            }),
        })
    );
};